import Citrus2 from '../Citrus/Citrus (1).webp'
import Citrus3 from '../Citrus/Citrus (2).webp'
import Citrus4 from '../Citrus/Citrus (3).webp'
import Citrus5 from '../Citrus/Citrus (4).webp'
import Citrus6 from '../Citrus/Citrus (5).webp'
import Citrus7 from '../Citrus/Citrus (6).webp'
import Citrus8 from '../Citrus/Citrus (7).webp'
import Citrus9 from '../Citrus/Citrus (8).webp'
import Citrus10 from '../Citrus/Citrus (9).webp'
import Citrus11 from '../Citrus/Citrus (10).webp'
import Citrus12 from '../Citrus/Citrus (11).webp'
import Citrus13 from '../Citrus/Citrus (12).webp'
import Citrus14 from '../Citrus/Citrus (13).webp'
import Citrus15 from '../Citrus/Citrus (14).webp'
import Citrus16 from '../Citrus/Citrus (15).webp'
import Citrus17 from '../Citrus/Citrus (16).webp'

const Citrusimages =[
    Citrus2,Citrus3,Citrus4,Citrus5,Citrus6,Citrus7,Citrus8,Citrus9,Citrus10,Citrus11,Citrus12,Citrus13,Citrus14,Citrus15,Citrus16,Citrus17
]

export default Citrusimages;